export default __webpack_public_path__ + "static/media/footerbanner.6c7d980b.jpg";